import { CommonModule } from '@angular/common';
import { Component, inject, output } from '@angular/core';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconsModule } from '@progress/kendo-angular-icons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import "@progress/kendo-date-math/tz/all";
import { UserPreferencesStore } from '@src/app/store/signal/user-preferences/user-preferences.store';

@Component({
  selector: 'cs-logout-only-menu',
  imports: [
    CommonModule,
    ButtonModule,
    IconsModule,
    LoaderModule,
    LayoutModule,
    ButtonsModule,
    DropDownsModule,
  ],
  templateUrl: './logout-only-menu.component.html',
  styleUrl: './logout-only-menu.component.scss'
})
export class LogoutOnlyMenuComponent {
  public readonly store = inject(UserPreferencesStore);
  logout = output();

  public handleLogout(): void {
    this.logout.emit();
  }
}
